export interface OnboardingChipsProps {
  label?: string;
  optional?: boolean;
  options: string[];
  value: string | string[];
  onChange: (value: string | string[]) => void;
  multiSelect?: boolean;
  disabled?: boolean;
}

export const OnboardingChips = ({
  label,
  optional,
  options,
  value,
  onChange,
  multiSelect = false,
  disabled,
}: OnboardingChipsProps) => {
  const isSelected = (option: string) => {
    if (multiSelect && Array.isArray(value)) {
      return value.includes(option);
    }
    return value === option;
  };

  const handleClick = (option: string) => {
    if (multiSelect && Array.isArray(value)) {
      const newValue = value.includes(option)
        ? value.filter((v) => v !== option)
        : [...value, option];
      onChange(newValue);
    } else {
      onChange(option);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className="text-left text-sm font-medium text-[#344051]">
          {label}{' '}
          {optional && <span className="text-[#98a2b3]">(optional)</span>}
        </label>
      )}
      <div className="flex flex-wrap gap-2.5">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => handleClick(option)}
            className={`rounded-2lg flex items-center gap-2 px-2.5 py-1.5 transition-colors disabled:cursor-not-allowed ${
              isSelected(option)
                ? 'bg-[#faf9ff] text-[#795dfc] ring ring-[#795dfc]'
                : 'bg-[#f2f4f7] text-[#141c25] hover:bg-[#e4e7ec]'
            }`}
            disabled={disabled}
          >
            <p className="text-left text-base">{option}</p>
          </button>
        ))}
      </div>
    </div>
  );
};
